export default {"src":"/_next/static/media/logo.07b04213.svg","height":30,"width":200};